var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboardArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 15.8751L12.88 11.9951L8.99999 8.1151C8.60999 7.7251 8.60999 7.0951 8.99999 6.7051C9.38999 6.3151 10.02 6.3151 10.41 6.7051L15 11.2951C15.39 11.6851 15.39 12.3151 15 12.7051L10.41 17.2951C10.02 17.6851 9.38999 17.6851 8.99999 17.2951C8.61999 16.9051 8.60999 16.2651 8.99999 15.8751Z",
    fill: "black",
    fillOpacity: 0.82
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowRight);
export default __webpack_public_path__ + "static/media/keyboard-arrow-right.940b515a143403a89563ce0b1e12f90d.svg";
export { ForwardRef as ReactComponent };